import * as type from '@/store/types'
import { event as gtagEvent } from 'vue-gtag'

export default function signInWithYandex({ to, next, store }) {
  const { code } = to.query
  if (code) {
    store.commit(type.SET_PROMISE_CHAIN, {
      name: type.SESSION,
      promise: null
    })

    store
      .dispatch(type.CREATE_SESSION_WITH_CODE, { code })
      .then(() => {
        const { model } = store.state[type.SESSION]
        if (model.isSignup) {
          gtagEvent('sign_up')
        } else {
          gtagEvent('login')
        }
        next({ name: 'select-account' })
      })
      .catch(() => {
        next({ query: null })
      })
  } else {
    next()
  }
}
